<template>
  <div>
    <div>
      <Base--InlineTextBlock>
        Сумма ставок: {{ stats.bets_sum }}
      </Base--InlineTextBlock>
      <Base--InlineTextBlock>
        Сумма выигрыша: {{ stats.prizes_sum }}
      </Base--InlineTextBlock>
      <Base--InlineTextBlock>
        Прибыль: {{ stats.profit }}
      </Base--InlineTextBlock>
    </div>
    <v-flex shrink class="row">
      <Base--InlineTextBlock>Установленный интервал между раундами</Base--InlineTextBlock>
      <div>
        <v-text-field
          v-model="delay"
          class="delay-input"
          mask="#####"
        />
      </div>
      <Base--InlineTextBlock style="margin-left: 10px">мс</Base--InlineTextBlock>
    </v-flex>
    <CrashStatisticsTable :items="statisticsRounds" :pull-function="getRounds" />
    <BaseSideButtons :save="save" back />
  </div>
</template>

<script>
import BaseSideButtons from '../Base--SideButtons'
import {
  getCrashDelay, getCrashGeneralStats, getCrashRoundsStats, updCrashDelay
} from '../../../api/crash'
import CrashStatisticsTable from '../common/Table/CrashStatisticsTable/CrashStatisticsTable'

export default {
  name: 'Crash',
  components: { CrashStatisticsTable, BaseSideButtons },
  data () {
    return {
      delay: 0,
      statisticsRounds: [],
      stats: {
        bets_sum: 0,
        prizes_sum: 0,
        profit: 0
      }
    }
  },
  created () {
    getCrashDelay().then(res => {
      this.delay = res.data.delay
    })
    this.getRounds(1)
    getCrashGeneralStats().then(res => {
      this.stats = res.data
    })
  },
  methods: {
    getRounds (page) {
      getCrashRoundsStats({ limit: 25, offset: (page - 1) * 25 }).then(response => {
        this.statisticsRounds = response.data
      })
    },
    save () {
      this.AxiosHelperShowResponce(updCrashDelay({ delay: this.delay }))
    }
  }
}
</script>

<style scoped>
    .row {
        display: flex;
        padding-top: 10px;
    }

    .row .title {
        padding-top: 8px;
    }

    .delay-input {
        margin: 0;
        padding: 0;
        width: 50px !important;
    }
</style>
